import {
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Box,
} from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useCustomAxios from '../../utils/helpers/customAxios';
import { useAlert } from '../Providers/AlertProvider';
import { UserSignUp } from '../../types/UserTypes';
import CustomLoadingButton from '../Custom/CustomLoadingButton';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { zodResolver } from '@hookform/resolvers/zod';
import { EmailSchema } from '../../utils/schema/userSchema';
import { useForm } from 'react-hook-form';

const CreateUserForm = ({
  setOpenModal,
  forgetPassword = false,
  text = 'Reset Password',
}: {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  forgetPassword?: boolean;
  text?: string;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState<boolean | null>(null);
  const { showAlert } = useAlert();
  const axiosInstance = useCustomAxios();
  const navigate = useNavigate();
  const [formData, setFormData] = useState<UserSignUp>({
    email: '',
  });
  const handleData = async (e: any) => {
    setIsLoading(true);
    try {
      const response = forgetPassword
        ? await axiosInstance.post('/mail/forget-password-link', formData)
        : await axiosInstance.post('/mail/signup', formData);
      if (!forgetPassword && response.data?.buttonUrl) {
        const url = new URL(response.data.buttonUrl);
        navigate(`${url.pathname}${url.search}`);
        return;
      }
      showAlert(
        'info',
        `Please procceed to your email to verify your account.`,
      );
      setOpenModal(false);
      setSuccess(true);
      setIsLoading(false);
      localStorage.removeItem('token');
    } catch (error: any) {
      showAlert('error', error?.response?.data?.message);
      setSuccess(false);
      setIsLoading(false);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserSignUp>({
    resolver: zodResolver(EmailSchema),
  });

  return (
    <Container maxWidth="xs">
      <Box
        style={{
          marginTop: '64px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h4" gutterBottom>
          {forgetPassword ? text : 'Sign Up'}
        </Typography>
        <form
          onSubmit={handleSubmit(handleData)}
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Grid
            container
            spacing={2}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Grid item xs={10}>
              <TextField
                {...register('email')}
                helperText={errors.email?.message}
                error={Boolean(errors.email?.message)}
                variant="outlined"
                fullWidth
                label="Email Address"
                name="email"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={2} justifyContent={'center'} alignItems={'center'}>
              <CustomLoadingButton
                loading={isLoading}
                success={success}
                Icon={<ArrowForward />}
                marginBottom="16px"
              />
            </Grid>
          </Grid>
        </form>
        <Grid container justifyContent="flex-end" style={{ marginTop: '16px' }}>
          <Grid item>
            {!forgetPassword && (
              <Button onClick={() => setOpenModal(false)}>
                Already have an account? Sign in
              </Button>
            )}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CreateUserForm;
